export const DEATAILS = {
  NUMBER: "",
  EMAIL: "",
};

export const ROUTES = {
  HOME: "/",
  LOGIN: "/login"
};

export const DEVICE_TYPE = {
  TYPE: 'web',
};

export const DEVICE_LANGUAGE = {
  ENGLISH: "en"
};
